import type { MasterSChatRecord } from "@variants/seer/master-s/shared/types/chat-record";

function getRecordOrder(item: MasterSChatRecord): number {
	return Number(item.created_at || item.date || item.id || 0);
}

export function normalizeMasterSChatRecords(list: MasterSChatRecord[]): MasterSChatRecord[] {
	return [...list].sort((a, b) => {
		const orderDiff = getRecordOrder(a) - getRecordOrder(b);
		if (orderDiff !== 0) return orderDiff;
		return Number(a.id || 0) - Number(b.id || 0);
	});
}

export type MasterSChatBubble = {
	role: "user" | "ai";
	text?: string;
	image?: string;
	/** 测算结果 answer（msg_type 8/32），需按 Markdown 渲染 */
	markdown?: boolean;
};

/** 与记录页一致的文案提取 */
export function getRecordText(item: MasterSChatRecord): string {
	const d = item.data || {};
	switch (item.msg_type) {
		case 1:
			return d.text || "";
		case 5:
			return d.question || "";
		case 8:
			return d.answer || "";
		case 32:
			return d.answer || "";
		case 33:
			return d.text || "";
		case 37:
			return d.text || "";
		default:
			return "";
	}
}

/** 塔罗 34 / 六爻 38：与参考项目 records 一致，取 data.image */
export function getRecordImage(item: MasterSChatRecord): string {
	const d = item.data || {};
	if (item.msg_type === 34 || item.msg_type === 38) return d.image || "";
	return "";
}

/** 转成对话框气泡；塔罗/六爻结果图一并展示 */
export function recordToChatBubble(item: MasterSChatRecord): MasterSChatBubble | null {
	const image = getRecordImage(item);
	if (image) {
		return {
			role: item.is_me ? "user" : "ai",
			image,
		};
	}
	const text = getRecordText(item);
	if (!text) return null;
	return {
		role: item.is_me ? "user" : "ai",
		text,
		markdown: item.msg_type === 8 || item.msg_type === 32,
	};
}
